/** Join class names, skipping falsy values. Our Tailwind utilities never conflict, so no merge step is needed. */
export function cx(...parts: Array<string | false | null | undefined>): string {
  return parts.filter(Boolean).join(" ");
}
